/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalUsuarioNoRegistrado.css';
import { HOST_SERVER } from '../../../constants';

class ModalUsuarioNoRegistrado extends React.Component {
  static redirectToRegistracion() {
    window.location.href = `${HOST_SERVER}smgnewsite/prepaga/registracion.php`;
  }

  componentDidMount() {
    $('#ModalUsuarioNoRegistrado').modal({
      backdrop: 'static',
      keyboard: false,
    });
    $('.close').hide();
  }

  render() {
    return (
      <div
        className="modal fade modal-admin in"
        id="ModalUsuarioNoRegistrado"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className={`${s.header} modal-header`}>
              <h4 className="modal-title" style={{ fontSize: '20px' }}>
                <b>Usuario no registrado</b>
              </h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className={`${s.icono}`}
                    width="68px"
                    height="68px"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z" />
                  </svg>
                </div>
              </div>
              <br />
              <div className="row row-text">
                <div className="col-md-12 text-center">
                  <p>
                    <b>
                      {`Su DNI ${$(
                        '#userField',
                      ).val()} no está registrado para utilizar en nuestro sitio web`}
                    </b>
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-6 text-center">
                <button
                  data-dismiss="modal"
                  className={`${s.boton_blanco} btn btn-default text-center`}
                  onClick={() => {
                    location.reload();
                  }}
                >
                  Cancelar
                </button>
              </div>
              <div className="col-6 text-center">
                <button
                  data-dismiss="modal"
                  className={`${s.boton_rojo} btn btn-danger text-center`}
                  onClick={() => {
                    ModalUsuarioNoRegistrado.redirectToRegistracion();
                  }}
                >
                  Registrarse
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(null, null)(withStyles(s)(ModalUsuarioNoRegistrado));



// WEBPACK FOOTER //
// ./src/components/Login/ModalUsuarioNoRegistrado/ModalUsuarioNoRegistrado.js